var map = {
	"./SentinelX_logo.png": 1081,
	"./SentinelX_logo_dark.png": 1082,
	"./SentinelX_logo_light.png": 1083,
	"./X.svg": 627,
	"./access_icon.png": 544,
	"./alert.mp3": 346,
	"./big_smartsampa_logo_dark.png": 548,
	"./big_smartsampa_logo_light.png": 549,
	"./camera.svg": 628,
	"./cameras_icon.png": 537,
	"./crm_icon.png": 545,
	"./dashboard_icon.png": 547,
	"./dispatch_icon.png": 542,
	"./events_icon.png": 541,
	"./facial_icon.png": 538,
	"./favicon.png": 1084,
	"./gcm_agent_icon.png": 543,
	"./hikvision_serial_no.png": 325,
	"./icon.png": 1085,
	"./logo.png": 1086,
	"./logo.svg": 629,
	"./logo1x.png": 1087,
	"./logo2x.png": 1088,
	"./logo3x.png": 1089,
	"./logo_access.png": 339,
	"./logo_cameras.png": 336,
	"./logo_crm.png": 344,
	"./logo_dashboard.png": 342,
	"./logo_dispatch.png": 338,
	"./logo_events.png": 340,
	"./logo_facial.png": 335,
	"./logo_gcm_agent.png": 341,
	"./logo_logs.png": 343,
	"./logo_lpr.png": 337,
	"./logo_smart_search_facial.png": 345,
	"./logs_icon.png": 546,
	"./lpr.png": 1090,
	"./lpr.svg": 630,
	"./lpr_icon.png": 540,
	"./panoramic.svg": 631,
	"./person-default-picture.png": 82,
	"./pin_civil_defense_vehicle.svg": 632,
	"./pin_event.svg": 326,
	"./pin_gcm_vehicle.svg": 633,
	"./pin_point_of_interest.svg": 234,
	"./pin_third_party.svg": 327,
	"./pin_viaturas.svg": 634,
	"./pinned.svg": 635,
	"./police-car-1-1.png": 1091,
	"./ptz.svg": 636,
	"./smart_search_facial_icon.png": 539,
	"./smartsampa_logo_dark.png": 535,
	"./smartsampa_logo_light.png": 536,
	"./splash.png": 1092,
	"./user-agent-dark.svg": 328,
	"./user-agent-light.svg": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1080;